// extracted by css-extract-rspack-plugin
export default {"cls1":"FeedbackPopover-cls1_EcM","cls2":"FeedbackPopover-cls2_BKQ FeedbackPopover-cls1_EcM"};